import React from "react"

export const TutorAvatar = ({ url = "#" }) => {
  return (
    <div className="opening-tutor-card_avatar-box">
      <img src={url} alt="Tutor avatar" />
    </div>
  )
}
